var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 2.40002C10.0905 2.40002 8.25918 3.15859 6.90892 4.50886C5.55866 5.85912 4.80009 7.69047 4.80009 9.60002V13.9032L3.95169 14.7516C3.78391 14.9194 3.66967 15.1332 3.62339 15.366C3.5771 15.5987 3.60087 15.84 3.69167 16.0592C3.78248 16.2785 3.93624 16.4658 4.13354 16.5977C4.33083 16.7296 4.56279 16.8 4.80009 16.8H19.2001C19.4374 16.8 19.6693 16.7296 19.8666 16.5977C20.0639 16.4658 20.2177 16.2785 20.3085 16.0592C20.3993 15.84 20.4231 15.5987 20.3768 15.366C20.3305 15.1332 20.2163 14.9194 20.0485 14.7516L19.2001 13.9032V9.60002C19.2001 7.69047 18.4415 5.85912 17.0913 4.50886C15.741 3.15859 13.9096 2.40002 12.0001 2.40002ZM12.0001 21.6C11.0453 21.6 10.1296 21.2207 9.4545 20.5456C8.77937 19.8705 8.40009 18.9548 8.40009 18H15.6001C15.6001 18.9548 15.2208 19.8705 14.5457 20.5456C13.8705 21.2207 12.9549 21.6 12.0001 21.6Z",
    fill: "#8D96B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.da7c863999c9ae6929fd0f54106c021a.svg";
export { ForwardRef as ReactComponent };